import http from "./httpService";

const getFileUrl = async (value: string | null | undefined, preview: boolean): Promise<string | null> => {
  if (!value) return null;
  try {
    const response = await http.get("/generate_download_url", {
      params: { file_name: value, preview },
    });
    return response.data?.downloadURL || value;
  } catch {
    return value;
  }
};

export const getResumePreviewUrl = (value: string | null | undefined): Promise<string | null> => {
  if (!value || /^https?:\/\//i.test(value)) {
    return Promise.resolve(value ?? null);
  }
  return getFileUrl(value, true);
};

export const getResumeDownloadUrl = (value: string | null | undefined): Promise<string | null> =>
  getFileUrl(value, false);

export const downloadBulkResumes = async (emails: string[]): Promise<void> => {
  if (!emails || emails.length === 0) return;
  try {
    const response = await http.post("/interviewiq/resumes/bulk-download", { emails }, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/zip'
      }
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'resumes.zip');
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to download bulk resumes", error);
    throw error;
  }
};
